import { iconFileUpload } from "assets/icons";
import { Button } from "components/Button";
import React, { useRef } from "react";
import { ErrorText, FileInfo, FileInputContainer, HiddenInput } from "./styles";

export interface InputTranscriptFileProps {
  onFileSelect: (file: File) => void;
  selectedFile?: File | null;
  error?: boolean;
  errorMessage?: string;
  accept?: string;
}

export const InputTranscriptFile: React.FC<InputTranscriptFileProps> = ({
  onFileSelect,
  selectedFile,
  error = false,
  errorMessage = "",
  accept = ".txt,.text,.pdf,.doc,.docx",
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const getFileTypeLabel = (filename: string): string => {
    const extension = filename
      .toLowerCase()
      .substring(filename.lastIndexOf("."));
    const fileTypeMap: { [key: string]: string } = {
      ".txt": "Texto",
      ".text": "Texto",
      ".pdf": "PDF",
      ".doc": "Word",
      ".docx": "Word",
      ".mp3": "Áudio MP3",
      ".wav": "Áudio WAV",
      ".m4a": "Áudio M4A",
      ".ogg": "Áudio OGG",
      ".flac": "Áudio FLAC",
    };
    return fileTypeMap[extension] || "Arquivo";
  };

  return (
    <FileInputContainer>
      <HiddenInput
        ref={fileInputRef}
        type="file"
        accept={accept}
        onChange={handleFileChange}
      />

      <Button
        label={selectedFile ? "Alterar Arquivo" : "Selecionar Arquivo"}
        typeBtn="outline"
        size="large"
        type="button"
        icon={iconFileUpload}
        onClick={handleButtonClick}
      />

      {selectedFile && (
        <FileInfo>
          <span className="file-name">{selectedFile.name}</span>
          <span className="file-details">
            {getFileTypeLabel(selectedFile.name)} •{" "}
            {formatFileSize(selectedFile.size)}
          </span>
        </FileInfo>
      )}

      {error && errorMessage && <ErrorText>{errorMessage}</ErrorText>}
    </FileInputContainer>
  );
};
